module.exports = {
    viewport_onestic: {
        xl: 1920,
        lg: 1024,
        md: 600,
        sm: 320,
    },
    viewport_bootstrap: {
        xl: 1400,
        xls: 1200,
        lg: 1024,
        lgs: 992,
        md: 768,
        sm: 576,
    },
    sfccAlertTime: 5000,
};
